import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import styles from './Login.modules.css';

export const Line = () => {
    return (
        <>
            <div>
                <div className="Head">
                    <div>
                        <div className="line"></div>
                    </div>
                </div>
            </div>
        </>
    )
}